import { render, staticRenderFns } from "./Discipline.vue?vue&type=template&id=7a645b61"
import script from "./Discipline.vue?vue&type=script&lang=js"
export * from "./Discipline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a645b61')) {
      api.createRecord('7a645b61', component.options)
    } else {
      api.reload('7a645b61', component.options)
    }
    module.hot.accept("./Discipline.vue?vue&type=template&id=7a645b61", function () {
      api.rerender('7a645b61', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/Discipline.vue"
export default component.exports